<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">年中不松劲，冲刺正当时</p>
        <p  class="font1" style="padding-top: 1vh;">点亮九月的学习新地图</p>

       <div class="wrapper">
            <p class="font2" style="padding-top: 2vh;text-align: left;font-weight: bold;">2025年9月富学宝典上热门课程：</p>
            <div style="width: 90%;margin: 0 auto;margin-top: 2vh;">
                <ul v-for="(item,index) in mergeBook.slice(0,3)" :key="index">
                    <label style="color: #fff;">
                        <input type="checkbox" :value="item.Name" v-model="selectedCourses"/>
                        {{ item.Name }}
                    </label>
                </ul>
            </div>

            <p class="font2" v-if="uncompletedLink.length>0" style="padding-top: 2vh;text-align: left;font-weight: bold;">以下课程已学习过半，您离完成目标只差一步之遥：</p>
            <div style="width: 90%;margin: 0 auto;margin-top: 1vh;">
                <ul v-for="(item,index) in mergeBook.slice(3)" :key="index">
                    <label style="color: #fff;">
                        <input type="checkbox" :value="item.Name" v-model="selectedCourses"/>
                        {{ item.Name }}
                    </label>
                </ul>
            </div>
       </div>
    </div>
</template>


<script>

export default {
    props: {
        ReportData: {
            type: Object,
            required: false
        },
        selected: {
            type: Array,
            default: () => []
        }
    },

      components:{},
      data() {
        return {
            topRecommendLink:'',
            uncompletedLink:[],
            mergeBook:'',
            selectedCourses: []
        }
      },
      created(){
        this.topRecommendLink=JSON.parse(this.ReportData.topRecommendLink)
        this.uncompletedLink=JSON.parse(this.ReportData.uncompletedLink)
        // console.log(this.uncompletedLink)
        this.mergeBook=this.topRecommendLink.concat(this.uncompletedLink)
    //   console.log(this.mergeBook,'书');
      },
      watch: {
        selectedCourses: {
            deep: true,
            handler(newVal) {
                this.$emit('update:selected', newVal);
            }
        }
    },
    mounted() {
        this.selectedCourses = [...this.selected];
    }
    }
</script>
  
<style scoped>
.body {
    background: 
                url("../../assets/25September/logo.png") right  top  no-repeat,
                url("../../assets/25September/bg.jpg")  no-repeat;
    background-size:100% 100%,cover;
    width: 100%;
    height: 100vh;
}
.wrapper{
    background-color:rgba(184, 185, 187, 0.5);
    border-radius: 10px;
    width: 96%;
    margin: 0 auto;
}

ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    /* text-align: center; */
}
li {
    align-items: center;
    margin-bottom: -13px; /* 可调整列表项之间的间距 */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 96%;
    margin: 0 auto;
    text-align: center;
    font-size: 20px;
    color: #0D1B2A;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #0D1B2A;
    font-size: 18px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 30px;
    font-weight: bolder;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #fff;
    text-shadow:  -1px -1px 0 #b68989, 1px -1px 0 #827f7f, -1px 1px 0 #827f7f, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
@media screen and (min-width: 786px) {
  .body {
    background: 
                url("../../assets/25September/pcbg.jpg")  no-repeat;
    background-size:cover;
    width: 100%;
    height: 100vh;
  }
  .wrapper {
    width: 70%;
    margin: 0 auto;
    padding-top: 8vh;
    font-size: 19px;
  }
}
</style>